const amountOfTaskMessagesOnPage = 20;

export default amountOfTaskMessagesOnPage;
